import _ from 'lodash';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';

export const SECTION_TYPE = {
  ARTICLE_TAGS: 'article-tags',
  ARTICLE_CATEGORIES: 'article-categories',
  VIDEO_TAGS: 'video-tags',
  VIDEO_CATEGORIES: 'video-categories'
};

function convertPathURI(type, names, limit) {
  const uri = [];
  switch (type) {
    case SECTION_TYPE.ARTICLE_TAGS:
      _.forEach(names, el => uri.push(GET(`/api/search/tag${convertObjPath({ name: el, limit })}`)));
      break;
    case SECTION_TYPE.ARTICLE_CATEGORIES:
      break;
    case SECTION_TYPE.VIDEO_TAGS:
      break;
    case SECTION_TYPE.VIDEO_CATEGORIES:
      break;
    default:
      break;
  }
  return uri;
}

export async function getSection({ type, topic, limit }) {
  try {
    // console.time('Event007');
    const names = [];
    let resData = [];
    let section = {
      footer: { desktop: '', mobile: '' },
      header: { desktop: '', mobile: '' },
      background: { desktop: '', mobile: '' },
      video: []
    };

    // GET : Datasets
    const datasets = await GET(
      `/api/datasets${convertObjPath({
        limit: 20
      })}`
    );

    // const result = datasets.filter((el: any) => topic.some((val: string) => val === el.topic));
    const result = datasets.filter(el => topic === el.topic);
    for (let i = 0; i < result.length; i++) {
      const _datasets = result[i].dataSet;
      for (let n = 0; n < _datasets.length; n++) {
        switch (_datasets[n].key) {
          case 'link-youtube':
            if (!_.isEmpty(_datasets[n]?.value)) {
              section.video.push({ video_src: _datasets[n]?.value, type_video: '2', is_video: true });
            }
            break;
          case 'ชื่อแท็ก':
            names.push(_datasets[n]?.value || '');
            if (!_.isEmpty(names)) {
              const paths = convertPathURI(type, names, limit);
              if (!_.isEmpty(paths)) {
                resData = await Promise.all(paths);
              }
              for (let x = 0; x < names.length; x++) {
                // console.log([`block${x + 1}`], names[x], resData[x]);
                section = {
                  ...section,
                  [`block${x + 1}`]: {
                    title: names[x],
                    link: `/tags/${names[x]}`,
                    data: resData[x]
                  }
                };
              }
            }
            break;
          case 'header-desktop':
          case 'header-mobile':
          case 'footer-desktop':
          case 'footer-mobile':
          case 'background-desktop':
          case 'background-mobile':
            section[_datasets[n]?.key.split('-')[0]] = {
              ...section[_datasets[n]?.key.split('-')[0]],
              [_datasets[n]?.key.split('-')[1]]: _datasets[n].value
            };
            break;
          default:
            break;
        }
      }
    }
    // console.timeEnd('Event007');
    return section;
  } catch (err) {
    console.error(`${timestamp()} ==========> GET_SECTION ERROR : `, err?.message);
  }
}
